module.exports = __webpack_public_path__ + "static/media/ref4.f0cf88d7.png";